import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { useUniquePrefix } from "../../../hooks/useUniquePrefix";
var ListIsEmpty = function(param) {
    var width = param.width, height = param.height, title = param.title;
    var uniqueID = useUniquePrefix();
    return _jsxs("svg", {
        width: width,
        height: height,
        viewBox: "0 0 335 291",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            _jsx("title", {
                children: title
            }),
            _jsxs("defs", {
                children: [
                    _jsx("rect", {
                        id: "".concat(uniqueID, "ListIsEmpty-path-1"),
                        x: "0",
                        y: "0",
                        width: "217.800007",
                        height: "49.6100016"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "ListIsEmpty-path-4"),
                        x: "19.3600006",
                        y: "13.3100004",
                        width: "217.800007",
                        height: "49.6100016"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "ListIsEmpty-path-7"),
                        x: "0",
                        y: "0",
                        width: "217.800007",
                        height: "50.8200016"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "ListIsEmpty-path-10"),
                        x: "19.3600006",
                        y: "13.3100004",
                        width: "217.800007",
                        height: "50.8200016"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "ListIsEmpty-path-13"),
                        x: "0",
                        y: "0",
                        width: "217.800007",
                        height: "50.8200016"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "ListIsEmpty-path-15"),
                        x: "19.3600006",
                        y: "13.3100004",
                        width: "217.800007",
                        height: "50.8200016"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "ListIsEmpty-path-18"),
                        x: "0",
                        y: "1.21000004",
                        width: "217.800007",
                        height: "49.6100016"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "ListIsEmpty-path-20"),
                        x: "0",
                        y: "70.1800022",
                        width: "217.800007",
                        height: "50.8200016"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "ListIsEmpty-path-23"),
                        x: "0",
                        y: "142.780005",
                        width: "217.800007",
                        height: "50.8200016"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "ListIsEmpty-path-35"),
                        x: "215.63684",
                        y: "128.260004",
                        width: "15.2905477",
                        height: "52.0468854"
                    }),
                    _jsx("rect", {
                        id: "".concat(uniqueID, "ListIsEmpty-path-38"),
                        x: "215.380007",
                        y: "188.850052",
                        width: "15.2905477",
                        height: "15.3079075",
                        rx: "7.64527387"
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "ListIsEmpty-linearGradient-3"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#00A7FA"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#0076F3"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "0%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "ListIsEmpty-linearGradient-9"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#00A7FA"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#0076F3"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "50%",
                        y1: "-2.48949813e-15%",
                        x2: "50%",
                        y2: "100%",
                        id: "".concat(uniqueID, "ListIsEmpty-linearGradient-22"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#0096F7"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#00FFD6"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "0%",
                        y1: "0%",
                        x2: "50%",
                        y2: "74.4382679%",
                        id: "".concat(uniqueID, "ListIsEmpty-linearGradient-25"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "0%",
                        y1: "4.25330813%",
                        x2: "50%",
                        y2: "72.3593982%",
                        id: "".concat(uniqueID, "ListIsEmpty-linearGradient-26"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "0%",
                        y1: "49.9879815%",
                        x2: "50%",
                        y2: "50.0058742%",
                        id: "".concat(uniqueID, "ListIsEmpty-linearGradient-27"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "0%",
                        y1: "49.7566252%",
                        x2: "50%",
                        y2: "50.1189532%",
                        id: "".concat(uniqueID, "ListIsEmpty-linearGradient-28"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "0%",
                        y1: "49.8077039%",
                        x2: "50%",
                        y2: "50.0939877%",
                        id: "".concat(uniqueID, "ListIsEmpty-linearGradient-29"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF",
                                stopOpacity: "0"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#FFFFFF"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "54.1773013%",
                        y1: "98.4207403%",
                        x2: "45.8042809%",
                        y2: "2.70733173%",
                        id: "".concat(uniqueID, "ListIsEmpty-linearGradient-34"),
                        children: [
                            _jsx("stop", {
                                offset: "0%",
                                stopColor: "#FFFFFF"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F7F8F9"
                            })
                        ]
                    }),
                    _jsxs("linearGradient", {
                        x1: "99.8866607%",
                        y1: "100%",
                        x2: "1.49748777%",
                        y2: "2.70733173%",
                        id: "".concat(uniqueID, "ListIsEmpty-linearGradient-37"),
                        children: [
                            _jsx("stop", {
                                offset: "1.62320524%",
                                stopColor: "#FFFFFF"
                            }),
                            _jsx("stop", {
                                offset: "100%",
                                stopColor: "#F7F8F9"
                            })
                        ]
                    }),
                    _jsx("filter", {
                        x: "-30.0%",
                        y: "-85.5%",
                        width: "160.1%",
                        height: "373.8%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-5"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "8.47000027",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsxs("filter", {
                        x: "-45.6%",
                        y: "-154.0%",
                        width: "191.3%",
                        height: "510.8%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-6"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "28",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "5",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "20",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "11",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.324501812 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsx("filter", {
                        x: "-30.0%",
                        y: "-83.5%",
                        width: "160.1%",
                        height: "367.3%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-11"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "8.47000027",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsxs("filter", {
                        x: "-45.6%",
                        y: "-150.4%",
                        width: "191.3%",
                        height: "501.1%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-12"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "28",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "5",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "20",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "11",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.324501812 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsx("filter", {
                        x: "-30.0%",
                        y: "-83.5%",
                        width: "160.1%",
                        height: "367.3%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-16"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "8.47000027",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsxs("filter", {
                        x: "-45.6%",
                        y: "-150.4%",
                        width: "191.3%",
                        height: "501.1%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-17"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "28",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "5",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "20",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "11",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.324501812 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-34.0%",
                        y: "-102.8%",
                        width: "168.0%",
                        height: "408.4%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-19"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "28",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "5",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "20",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "11",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.324501812 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-34.0%",
                        y: "-100.4%",
                        width: "168.0%",
                        height: "401.1%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-21"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "28",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "5",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "20",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "11",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.324501812 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-34.0%",
                        y: "-100.4%",
                        width: "168.0%",
                        height: "401.1%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-24"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "28",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "5",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "20",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "11",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.324501812 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0.560784314 0 0 0 0 0.964705882 0 0 0 0.402032382 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsx("filter", {
                        x: "-16.7%",
                        y: "-71.4%",
                        width: "133.3%",
                        height: "242.9%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-32"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "12.1000004",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsx("filter", {
                        x: "-16.7%",
                        y: "-71.4%",
                        width: "133.3%",
                        height: "242.9%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-33"),
                        children: _jsx("feGaussianBlur", {
                            stdDeviation: "12.1000004",
                            in: "SourceGraphic"
                        })
                    }),
                    _jsxs("filter", {
                        x: "-569.0%",
                        y: "-132.6%",
                        width: "1238.0%",
                        height: "434.3%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-36"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "18",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "6",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "26",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "9",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsxs("filter", {
                        x: "-569.0%",
                        y: "-450.7%",
                        width: "1238.0%",
                        height: "1236.7%",
                        filterUnits: "objectBoundingBox",
                        id: "".concat(uniqueID, "ListIsEmpty-filter-39"),
                        children: [
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "18",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            _jsx("feOffset", {
                                dx: "0",
                                dy: "6",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter2"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "26",
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1"
                            }),
                            _jsx("feGaussianBlur", {
                                stdDeviation: "9",
                                in: "shadowOffsetOuter2",
                                result: "shadowBlurOuter2"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
                                type: "matrix",
                                in: "shadowBlurOuter1",
                                result: "shadowMatrixOuter1"
                            }),
                            _jsx("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
                                type: "matrix",
                                in: "shadowBlurOuter2",
                                result: "shadowMatrixOuter2"
                            }),
                            _jsxs("feMerge", {
                                children: [
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter1"
                                    }),
                                    _jsx("feMergeNode", {
                                        in: "shadowMatrixOuter2"
                                    })
                                ]
                            })
                        ]
                    }),
                    _jsx("circle", {
                        id: "".concat(uniqueID, "ListIsEmpty-path-30"),
                        cx: "70.7850022",
                        cy: "70.7850022",
                        r: "70.7850022"
                    })
                ]
            }),
            _jsx("g", {
                stroke: "none",
                fill: "none",
                strokeWidth: "1",
                fillRule: "evenodd",
                children: _jsx("g", {
                    id: "".concat(uniqueID, "ListIsEmpty-Hero/Error/List-is-Empty"),
                    transform: "translate(-15.000000, -53.000000)",
                    children: _jsxs("g", {
                        transform: "translate(55.000000, 69.000000)",
                        children: [
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-48"),
                                stroke: "#E1E1E1",
                                x: "18.1500006",
                                y: "162.140005",
                                width: "205.700006",
                                height: "44.7700014",
                                strokeWidth: "0.650949388"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-50"),
                                stroke: "#E1E1E1",
                                x: "18.1500006",
                                y: "85.9100027",
                                width: "205.700006",
                                height: "44.7700014",
                                strokeWidth: "0.650949388"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-52"),
                                stroke: "#E1E1E1",
                                x: "18.1500006",
                                y: "15.7300005",
                                width: "205.700006",
                                height: "45.9800014",
                                strokeWidth: "0.650949388"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-49"),
                                stroke: "#E1E1E1",
                                x: "21.7800007",
                                y: "153.670005",
                                width: "205.700006",
                                height: "44.7700014",
                                strokeWidth: "0.650949388"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-51"),
                                stroke: "#E1E1E1",
                                x: "29.0400009",
                                y: "78.6500025",
                                width: "205.700006",
                                height: "44.7700014",
                                strokeWidth: "0.650949388"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-53"),
                                stroke: "#E1E1E1",
                                x: "24.2000008",
                                y: "8.47000027",
                                width: "205.700006",
                                height: "44.7700014",
                                strokeWidth: "0.650949388"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-60"),
                                fill: "#FFFFFF",
                                x: "0",
                                y: "1.21000004",
                                width: "217.800007",
                                height: "49.6100016"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-61"),
                                fill: "#FFFFFF",
                                x: "0",
                                y: "70.1800022",
                                width: "217.800007",
                                height: "50.8200016"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-62"),
                                fill: "#FFFFFF",
                                x: "0",
                                y: "142.780005",
                                width: "217.800007",
                                height: "50.8200016"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-81"),
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-22)"),
                                x: "0",
                                y: "70.1800022",
                                width: "217.800007",
                                height: "50.8200016",
                                strokeWidth: "2.42000008"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-82"),
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-22)"),
                                x: "0",
                                y: "0",
                                width: "217.800007",
                                height: "50.8200016",
                                strokeWidth: "2.42000008"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-69"),
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-27)"),
                                fill: "#ECECEC",
                                x: "47.1900015",
                                y: "15.7300005",
                                width: "156.090005",
                                height: "2.42000008",
                                rx: "1.21000004",
                                strokeWidth: "1.34164793",
                                fillOpacity: "0.7"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-70"),
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-27)"),
                                fill: "#ECECEC",
                                x: "47.1900015",
                                y: "85.9100027",
                                width: "156.090005",
                                height: "2.42000008",
                                rx: "1.21000004",
                                strokeWidth: "1.34164793",
                                fillOpacity: "0.7"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-71"),
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-27)"),
                                fill: "#ECECEC",
                                x: "47.1900015",
                                y: "158.510005",
                                width: "156.090005",
                                height: "2.42000008",
                                rx: "1.21000004",
                                strokeWidth: "1.34164793",
                                fillOpacity: "0.7"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-72"),
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-28)"),
                                fill: "#ECECEC",
                                x: "47.1900015",
                                y: "25.4100008",
                                width: "156.090005",
                                height: "10.8900003",
                                rx: "1.21000004",
                                strokeWidth: "1.34164793",
                                fillOpacity: "0.7"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-73"),
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-29)"),
                                fill: "#ECECEC",
                                x: "47.1900015",
                                y: "95.590003",
                                width: "156.090005",
                                height: "9.68000031",
                                rx: "1.21000004",
                                strokeWidth: "1.34164793",
                                fillOpacity: "0.7"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-74"),
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-29)"),
                                fill: "#ECECEC",
                                x: "47.1900015",
                                y: "168.190005",
                                width: "156.090005",
                                height: "9.68000031",
                                rx: "1.21000004",
                                strokeWidth: "1.34164793",
                                fillOpacity: "0.7"
                            }),
                            _jsx("rect", {
                                id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-83"),
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-22)"),
                                x: "0",
                                y: "142.780005",
                                width: "217.800007",
                                height: "50.8200016",
                                strokeWidth: "2.42000008"
                            }),
                            _jsxs("g", {
                                transform: "translate(0.000000, 1.210000)",
                                children: [
                                    _jsx("mask", {
                                        id: "".concat(uniqueID, "ListIsEmpty-mask-2"),
                                        fill: "white",
                                        children: _jsx("use", {
                                            xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-1")
                                        })
                                    }),
                                    _jsx("use", {
                                        fill: "#ECECEC",
                                        fillOpacity: "0.7",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-1")
                                    }),
                                    _jsxs("g", {
                                        filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-5)"),
                                        mask: "url(#".concat(uniqueID, "ListIsEmpty-mask-2)"),
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-6)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-4")
                                            }),
                                            _jsx("use", {
                                                fill: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-3)"),
                                                fillRule: "evenodd",
                                                xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-4")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(0.000000, 70.180002)",
                                children: [
                                    _jsx("mask", {
                                        id: "".concat(uniqueID, "ListIsEmpty-mask-8"),
                                        fill: "white",
                                        children: _jsx("use", {
                                            xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-7")
                                        })
                                    }),
                                    _jsx("use", {
                                        fill: "#ECECEC",
                                        fillOpacity: "0.7",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-7")
                                    }),
                                    _jsxs("g", {
                                        filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-11)"),
                                        mask: "url(#".concat(uniqueID, "ListIsEmpty-mask-8)"),
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-12)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-10")
                                            }),
                                            _jsx("use", {
                                                fill: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-9)"),
                                                fillRule: "evenodd",
                                                xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-10")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                transform: "translate(0.000000, 142.780005)",
                                children: [
                                    _jsx("mask", {
                                        id: "".concat(uniqueID, "ListIsEmpty-mask-14"),
                                        fill: "white",
                                        children: _jsx("use", {
                                            xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-13")
                                        })
                                    }),
                                    _jsx("use", {
                                        fill: "#ECECEC",
                                        fillOpacity: "0.7",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-13")
                                    }),
                                    _jsxs("g", {
                                        filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-16)"),
                                        mask: "url(#".concat(uniqueID, "ListIsEmpty-mask-14)"),
                                        children: [
                                            _jsx("use", {
                                                fill: "black",
                                                filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-17)"),
                                                fillOpacity: "1",
                                                xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-15")
                                            }),
                                            _jsx("use", {
                                                fill: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-9)"),
                                                fillRule: "evenodd",
                                                xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-15")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-19)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-18")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-3)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-18")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-21)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-20")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-9)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-20")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-24)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-23")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-9)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-23")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                id: "ListIsEmpty-Rectangle-Copy-67-+-Rectangle-Copy-68-Mask",
                                transform: "translate(152.460005, 95.590003)",
                                children: [
                                    _jsx("mask", {
                                        id: "".concat(uniqueID, "ListIsEmpty-mask-31"),
                                        fill: "white",
                                        children: _jsx("use", {
                                            xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-30")
                                        })
                                    }),
                                    _jsx("use", {
                                        fill: "#ECECEC",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-30")
                                    }),
                                    _jsx("rect", {
                                        id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-67"),
                                        fill: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-9)"),
                                        filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-32)"),
                                        mask: "url(#".concat(uniqueID, "ListIsEmpty-mask-31)"),
                                        x: "-152.460005",
                                        y: "-25.4100008",
                                        width: "217.800007",
                                        height: "50.8200016"
                                    }),
                                    _jsx("rect", {
                                        id: "".concat(uniqueID, "ListIsEmpty-Rectangle-Copy-68"),
                                        fill: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-9)"),
                                        filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-33)"),
                                        mask: "url(#".concat(uniqueID, "ListIsEmpty-mask-31)"),
                                        x: "-152.460005",
                                        y: "47.1900015",
                                        width: "217.800007",
                                        height: "50.8200016"
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-36)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-35")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-34)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-35")
                                    })
                                ]
                            }),
                            _jsxs("g", {
                                children: [
                                    _jsx("use", {
                                        fill: "black",
                                        filter: "url(#".concat(uniqueID, "ListIsEmpty-filter-39)"),
                                        fillOpacity: "1",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-38")
                                    }),
                                    _jsx("use", {
                                        fill: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-37)"),
                                        fillRule: "evenodd",
                                        xlinkHref: "#".concat(uniqueID, "ListIsEmpty-path-38")
                                    })
                                ]
                            }),
                            _jsx("circle", {
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-25)"),
                                fill: "#ECECEC",
                                cx: "22.3850007",
                                cy: "26.0150008",
                                r: "13.9150004",
                                strokeWidth: "1.34164793",
                                fillOpacity: "0.7"
                            }),
                            _jsx("circle", {
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-25)"),
                                fill: "#ECECEC",
                                cx: "22.3850007",
                                cy: "167.585005",
                                r: "13.9150004",
                                strokeWidth: "1.34164793",
                                fillOpacity: "0.7"
                            }),
                            _jsx("circle", {
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-25)"),
                                cx: "223.245007",
                                cy: "166.375005",
                                r: "70.7850022",
                                strokeWidth: "1.34164793"
                            }),
                            _jsx("ellipse", {
                                id: "".concat(uniqueID, "ListIsEmpty-Oval-Copy-24"),
                                stroke: "url(#".concat(uniqueID, "ListIsEmpty-linearGradient-26)"),
                                fill: "#ECECEC",
                                cx: "22.3850007",
                                cy: "95.590003",
                                rx: "13.9150004",
                                ry: "13.3100004",
                                strokeWidth: "1.34164793",
                                fillOpacity: "0.7"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
ListIsEmpty.defaultProps = {
    height: 400,
    width: 400
};
export default ListIsEmpty;
